import React from 'react';
import './Principles.scss';

const PRINCIPLES = [
  {
    title: 'Construir productos, no proyectos.',
    description: 'Invertimos en ideas que poseemos, no en horas que facturamos.',
  },
  {
    title: 'El diseño importa tanto como el código.',
    description: 'Cada detalle es una decisión. La calidad no es opcional.',
  },
  {
    title: 'Valor sobre hype.',
    description: 'Enviamos lo que resuelve problemas reales, no lo que las tendencias exigen.',
  },
  {
    title: 'Solo construimos lo que nos enorgullece.',
    description: 'Si no cumple con nuestro estándar, no se envía.',
  },
];

const Principles: React.FC = () => {
  return (
    <section className="principles">
      <div className="container">
        <div className="principles__header">
          <p className="principles__label">Principios</p>
          <h2 className="principles__title">
            Cómo <span className="gradient-text">trabajamos</span>.
          </h2>
        </div>

        <ol className="principles__list">
          {PRINCIPLES.map((p, i) => (
            <li key={p.title} className="principles__item">
              <span className="principles__num">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div>
                <h3 className="principles__item-title">{p.title}</h3>
                <p className="principles__item-desc">{p.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Principles;
